function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobiworkxIcon = function SvgMobiworkxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 50 50"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 32.3 11.7-16.6L47.7 1.1H36.2L25.8 15.7l-6 8.3-6-8.4H2.3l11.8 16.6h11.5z",
    style: {
      fill: "#ff4e00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 32.3 2.3 48.9h11.5l6-8.3 6 8.3h11.5L25.6 32.3z",
    style: {
      fill: "#3c3c3c"
    }
  }));
};
export default SvgMobiworkxIcon;